import { useState } from 'react';

import { StatusDropdown } from '@/components/ui/status-dropdown';
import { useTranslation } from '@hooks/useTranslation';
import { useUpdateInventoryStatus } from '@hooks/useInventories';

import {
  createInventoryStatusDropdownConfig,
  type InventoryStatus,
} from './inventory-status-config';

interface InventoryStatusDropdownProps {
  inventoryId: number;
  active: boolean;
}

export function InventoryStatusDropdown({ inventoryId, active }: InventoryStatusDropdownProps) {
  const { t } = useTranslation();
  const [currentActive, setCurrentActive] = useState(active);
  const updateStatus = useUpdateInventoryStatus();

  const config = createInventoryStatusDropdownConfig({
    active: t('common.status.active'),
    inactive: t('common.status.inactive'),
  });

  const value: InventoryStatus = currentActive ? 'active' : 'inactive';

  const handleChange = (next: InventoryStatus) => {
    const nextActive = next === 'active';
    if (nextActive === currentActive) return;
    setCurrentActive(nextActive);
    updateStatus.mutate({ id: inventoryId, active: nextActive });
  };

  return <StatusDropdown value={value} config={config} onChange={handleChange} />;
}
